import React from 'react'

const Maps = () => {
  return (
    <>
      <div className="mx-5 md:px-20 lg:px-30 lg:py-10 md:py-10">
      <div>
        <div  className="sm:p-4 md:px-10 md:py-10 lg:px-20 lg:py-10 md:flex lg:flex md:space-x-10 lg:space-x-10 lg:justify-between ">
        <iframe className="lg:h-96 lg:w-full  md:h-96 md:w-11/12 sm:h-60 sm:w-5/6 " src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3441.265880087331!2d78.07678871505124!3d30.400197481754223!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3908d70603f128a5%3A0x359bb8f9c7797984!2sDIT%20University!5e0!3m2!1sen!2sin!4v1677876018920!5m2!1sen!2sin"   allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
      </div>
      </div>
    </>
  )
}

export default Maps
